import { Filters } from '../../components/Filters/Filters';
import MainTab from '../../components/MainTab/MainTab';
import { ErrorBoundary } from 'react-error-boundary';
import ErrorComponent from '../../components/ErrorComponent/ErrorComponent';
import { useAppSelector } from '../../hooks/hooks';


export const MainPage = () => {
  const filters = useAppSelector((state) => state.filters);
  return (
    <>
      <Filters />
      <div className="table-wrapper">
        <ErrorBoundary FallbackComponent={ErrorComponent} resetKeys={[filters]}>
          <MainTab />
        </ErrorBoundary>
      </div>
    </>
  );
};